import type { SoulMapDocumentPhase } from '@/utils/soulmap-document-view';
import { useEffect, useRef, useState } from 'react';

/** Covers the reveal: the panel takes 520 ms and the last arc node ends at 970 ms. */
const REVEAL_WINDOW_MS = 1500;

/**
 * True for a moment after the Soul Map document turns ready while the chat is
 * open, so the reveal animation plays then, and not on every later page load
 * or when the message list refreshes and remounts the card.
 */
export function useSoulMapDocumentReveal(
  phase: SoulMapDocumentPhase | null
): boolean {
  const previousPhaseRef = useRef(phase);
  const [isRevealing, setIsRevealing] = useState(false);

  useEffect(() => {
    const previousPhase = previousPhaseRef.current;
    previousPhaseRef.current = phase;
    if (phase === 'ready' && previousPhase !== null && previousPhase !== 'ready') {
      setIsRevealing(true);
    }
  }, [phase]);

  useEffect(() => {
    if (!isRevealing) {
      return;
    }
    const timer = window.setTimeout(
      () => setIsRevealing(false),
      REVEAL_WINDOW_MS
    );
    return () => window.clearTimeout(timer);
  }, [isRevealing]);

  return isRevealing;
}
